export default __webpack_public_path__ + "static/media/loginSvgSimer.0ce5520e.svg";